/* @flow */

import mousetrap from 'mousetrap';
import { createSelector } from 'reselect';
import * as Loading from './loading';
import { type State, type GetState } from '../preact-app/types';

import {
    type BindParam,
    type BindAction,
    type UnbindAction,
    type Action,
    type Atalho,
    type AtalhosState,
} from './atalhos-types';

// Action Types

const BIND = 'atalhos/BIND';
const UNBIND = 'atalhos/UNBIND';

// Loading

const MODAL_ATALHOS = 'MODAL_ATALHOS';

// Action creators

const bindCreator = (tecla: string, descricao: string): BindAction => ({
    type: BIND,
    tecla,
    descricao,
});

const unbindCreator = (tecla: string): UnbindAction => ({
    type: UNBIND,
    tecla,
});

const abrirModal = () => Loading.init([{ nome: MODAL_ATALHOS, mensagem: '' }]);

// Selectors

export const getAtalhos = (state: State): Atalho[] => state.atalhos;

const traduzirTecla = (tecla: string) => {
    switch (tecla) {
    case 'up':
        return '↑';
    case 'down':
        return '↓';
    case 'left':
        return '←';
    case 'right':
        return '→';
    default:
        return tecla;
    }
};

export const getAtalhosView: State => Atalho[] = createSelector(
    getAtalhos,
    atalhos => atalhos
        .map(({ tecla, descricao }) => ({ tecla: traduzirTecla(tecla), descricao }))
        .sort(({ tecla: a }, { tecla: b }) => (a === '?' ? 1 : a.localeCompare(b))),
);

export const getExisteAtalhos: State => boolean = createSelector(
    getAtalhos,
    atalhos => atalhos.filter(({ tecla }) => tecla !== '?').length > 0,
);

export const getMostrarPopupAtalhos: State => boolean = createSelector(
    [Loading.getLoading],
    loading => !!loading.find(({ nome }) => nome === MODAL_ATALHOS),
);

// Thunks

export const toggleModal = () => (dispatch: Function, getState: GetState) => (
    getMostrarPopupAtalhos(getState())
        ? dispatch(Loading.destroy())
        : dispatch(abrirModal())
);

export const bind = ({ tecla, descricao, fn }: BindParam) => (dispatch: Function) => {
    dispatch(bindCreator(tecla, descricao));
    mousetrap.bind(tecla, fn);
};

export const unbind = (tecla: string) => (dispatch: Function) => {
    dispatch(unbindCreator(tecla));
    mousetrap.unbind(tecla);
};

// Reducer

const atalhosReducer = (state: AtalhosState = [], action: Action): AtalhosState => {
    switch (action.type) {
    case BIND: {
        const { tecla, descricao } = action;
        return [...state, { tecla, descricao }];
    }
    case UNBIND:
        return state.filter(atalho => atalho.tecla !== action.tecla);
    default:
        return state;
    }
};

export default atalhosReducer;
